<template>
  <div
    class="m--auto"
    :class="theme.type === 'type-e' ? 'p--40px' : themeClasses('boardWidth')"
  >
    <strong class="font--21px font--600 pb--24px block">{{boardMeta.boardName}} {{isEditMode ? '수정' : isCreateMode ? '작성': isViewMode ? '보기' : '답변'}}</strong>
    <form
      @submit.prevent="submit"
      @input="error.errorMessage = ''"
    >
      <template v-for="meta in boardMeta.fieldMeta">

        <text-field-input
          v-if="!user.userId && meta.fieldId === 'userName'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          :readonly="isViewMode || isAnswerMode"
          v-model="row.userName"
          label="사용자명"
          name="userName"
          placeholder="사용자명을 입력하세요."
        ></text-field-input>
        <!-- :helpText="''" -->

        <text-field-input
          v-if="!user.userId && (isCreateMode || isEditMode) && meta.fieldId === 'boardPassword'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.boardPassword"
          label="비밀번호"
          type="text"
          name="boardPassword"
          placeholder="비밀번호를 입력하세요."
        ></text-field-input>

        <text-field-input
          v-if="meta.fieldId === 'key'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          :readonly="isViewMode || isAnswerMode"
          v-model="row.key"
          label="고유키"
          name="key"
          placeholder="고유키을 입력하세요."
        ></text-field-input>

        <template v-if="meta.fieldId === 'filter'">
          <text-field-input
            v-if="!boardMeta.filters"
            :key="meta.fieldId"
            :required="meta.isRequired"
            :error="error"
            v-model="row.filter"
            :label="meta.label || '카테고리'"
            name="filter"
            :readonly="isViewMode || isAnswerMode"
            :placeholder="meta.placeholder || ''"
          ></text-field-input>
          <text-field-select
            v-else
            :key="meta.fieldId"
            :required="meta.isRequired"
            :error="error"
            v-model="row.filter"
            :label="meta.label || '카테고리'"
            name="filter"
            :readonly="isViewMode || isAnswerMode"
            :placeholder="meta.placeholder || '선택해주세요'"
            :options="boardMeta.filters"
          ></text-field-select>
        </template>

        <text-field-input
          v-if="meta.fieldId === 'title'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.title"
          label="제목"
          name="title"
          :readonly="isViewMode || isAnswerMode"
          placeholder="제목을 입력하세요."
        ></text-field-input>

        <text-field-textarea
          v-if="meta.fieldId === 'components'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="stringifyComponents"
          label="components"
          name="components"
          :readonly="isViewMode || isAnswerMode"
        ></text-field-textarea>
        <button
          v-if="meta.fieldId === 'components'"
          :key="`${meta.fieldId}_button`"
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="goTree"
        >
          컴포넌트 트리 보기
        </button>

        <text-field-textarea
          v-if="meta.fieldId === 'content' && meta.isHtml === false"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.content"
          :label="meta.label || '컨텐츠'"
          name="content"
          :readonly="isViewMode || isAnswerMode"
        ></text-field-textarea>

        <text-field-editor
          v-if="meta.fieldId === 'content' && meta.isHtml !== false"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          :readonly="isViewMode || isAnswerMode"
          :url="`/api/boards/${boardMeta.boardId}/files/`"
          :uuid="row.uuid"
          v-model="row.content"
          :label="meta.label || '컨텐츠'"
          name="content"
        ></text-field-editor>

        <text-field-editor
          v-if="isAnswerMode && boardMeta.useOptions.answerFlag === 'Y' && meta.fieldId === 'content'"
          :key="`${meta.fieldId}-answer`"
          :required="meta.isRequired"
          :error="error"
          :readonly="!isAnswerMode || user.level < $utils.getLevel(boardMeta.roles.answer)"
          :url="`/api/boards/${boardMeta.boardId}/files/`"
          :uuid="row.uuid"
          v-model="row.answer"
          label="답변"
          name="answer"
        ></text-field-editor>

        <text-field-toggle
          v-if="boardMeta.secretType === 'ON' && meta.fieldId === 'secretFlag'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.secretFlag"
          true-value="Y"
          false-value="N"
          :readonly="isViewMode || isAnswerMode"
          label="비밀글 여부"
          name="secretFlag"
          help-text="ON 으로 변경시 비밀글로 지정되어 본인만 읽을 수 있습니다."
        ></text-field-toggle>

        <text-field-toggle
          v-if="meta.fieldId === 'useFlag'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.useFlag"
          true-value="Y"
          false-value="N"
          :readonly="isViewMode || isAnswerMode"
          label="공개 여부"
          name="useFlag"
          help-text="OFF 로 변경시 화면에 출력되지 않습니다."
        ></text-field-toggle>

        <text-field-toggle
          v-if="user.role !== '' && user.role !== 'user' && meta.fieldId === 'noticeFlag'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.noticeFlag"
          true-value="Y"
          false-value="N"
          :readonly="isViewMode || isAnswerMode"
          label="공지사항 여부"
          name="noticeFlag"
          help-text="ON 으로 변경시 공지사항으로 지정됩니다."
        ></text-field-toggle>

        <text-field-uploads
          v-if="meta.fieldId === 'files'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          :uploadStatus="uploadStatus"
          :readonly="!isAnswerMode/* || user.level < $utils.getLevel(boardMeta.roles.answer)*/"
          :url="`/api/boards/${boardMeta.boardId}/files/`"
          :uuid="row.uuid"
          :files="row.files"
          :limit="meta.max"
          :accept="meta.accepts || []"
          :label="meta.label || '파일 선택'"
          name="files"
          @removeFile="removeFile"
          @error="onFileError"
          @fileUpload="onFileUpload"
        ></text-field-uploads>

        <text-field-thum-files
          v-if="meta.fieldId === 'thumbnails'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          :readonly="!isAnswerMode /* || user.level < $utils.getLevel(boardMeta.roles.answer)*/"
          :url="`/api/boards/${boardMeta.boardId}/files/`"
          :uuid="row.uuid"
          :files="row.thumbnails"
          :limit="meta.max"
          :accept="meta.accepts || []"
          :label="meta.label || '썸네일 선택'"
          name="thumbnails"
          @removeFile="removeThumbnail"
          @error="onFileError"
          @fileUpload="onFileUpload"
        ></text-field-thum-files>

        <!-- 
        <template v-if="meta.fieldId === 'files'">
          <text-field-thum-files
            v-if="meta.mode && meta.mode === 'thumbnail'"
            :key="meta.fieldId"
            :required="meta.isRequired"
            :error="error"
            :readonly="!isAnswerMode /* || user.level < $utils.getLevel(boardMeta.roles.answer)*/"
            :url="`/api/boards/${boardMeta.boardId}/files/`"
            :uuid="row.uuid"
            :files="row.files"
            :limit="boardMeta.fileMaxCnt"
            :accept="meta.accepts || []"
            :label="meta.label || '파일 선택'"
            name="files"
            @removeFile="removeFile"
            @error="onFileError"
            @fileUpload="onFileUpload"
          ></text-field-thum-files>
          <text-field-uploads
            v-else
            :key="meta.fieldId"
            :required="meta.isRequired"
            :error="error"
            :uploadStatus="uploadStatus"
            :readonly="!isAnswerMode/* || user.level < $utils.getLevel(boardMeta.roles.answer)*/"
            :url="`/api/boards/${boardMeta.boardId}/files/`"
            :uuid="row.uuid"
            :files="row.files"
            :limit="boardMeta.fileMaxCnt"
            :accept="meta.accepts || []"
            :label="meta.label || '파일 선택'"
            name="files"
            @removeFile="removeFile"
            @error="onFileError"
            @fileUpload="onFileUpload"
          ></text-field-uploads>

        </template> -->

        <div
          v-if="boardMeta.etcMeta.length > 0 && meta.fieldId === 'etc'"
          :key="meta.fieldId"
        >
          <text-field-input
            v-for="etc in boardMeta.etcMeta"
            :key="etc.fieldId"
            :required="etc.isRequired"
            :error="error"
            :value="row.etc[etc.fieldId]"
            :label="etc.label"
            :name="etc.fieldId"
            :type="etc.fieldType === 'integer' ? 'number' : 'text'"
            :placeholder="etc.placeholder"
            :readonly="isViewMode || isAnswerMode"
            @input="input(etc.fieldId, $event)"
          ></text-field-input>
        </div>

        <text-field-input
          v-if="meta.fieldId === 'tags'"
          :key="meta.fieldId"
          :required="meta.isRequired"
          :error="error"
          v-model="row.tags"
          label="태그"
          name="tags"
          :readonly="isViewMode || isAnswerMode"
          placeholder="태그를 쉼표로 분리하여 입력하세요."
        ></text-field-input>

      </template>
      <div class="pt--20px text--center">
        <button
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="goList"
        >
          돌아가기
        </button>
        <button
          v-if="isViewMode && hasEditRole"
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="goEdit"
        >
          수정
        </button>
        <button
          v-if="isViewMode && boardMeta.useOptions.answerFlag === 'Y' && user.level >= $utils.getLevel(boardMeta.roles.answer)"
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="goAnswer"
        >
          답변
        </button>
        <button
          v-if="isViewMode && hasEditRole"
          type="button"
          class="btn btn--xxxl border border--gray border--lighten-2 mr--4px"
          @click="remove"
        >
          삭제
        </button>
        <button
          type="submit"
          v-if="!isViewMode"
          class="btn btn--xxxl black ml--4px text--white"
        >저장하기</button>
      </div>
    </form>

    <!--

    <text-field-select></text-field-select>

    <text-field-toggle></text-field-toggle>

    <text-field-upload></text-field-upload>

    <text-field-textarea></text-field-textarea>

    <text-field-editor></text-field-editor> -->
    <!--
    <form
      class="w--1000px p--50px pt--30px"
      @submit.prevent="submit"
    >
      <div
        class="post-write"
        @input="error.errorMessage = ''"
      >
        <div class="post-write__head">
          <template v-for="meta in boardMeta.fieldMeta">
            <div
              class="pb--30px"
              v-if="boardMeta.fileMaxCnt > 0 && meta.fieldId === 'files'"
              :key="meta.fieldId"
            >
              <div class="post-thum clearfix">
                <strong
                  class="font--20px mb--8px"
                  :class="meta.isRequired ? 'is-essential' : ''"
                >파일 선택</strong>

                <form-files
                  :url="`/api/boards/${boardMeta.boardId}/files/`"
                  :files="row.files"
                  :uuid="row.uuid"
                  :limit="boardMeta.fileMaxCnt"
                  :error="error"
                  :accept="meta.accepts || ''"
                  name="files"
                  @removeFile="removeFile"
                  @error="onFileError"
                />
                <div class="thum-upload__notice pt--40px oveflow--hidden">
                  <p class="font--14px">
                    <strong>권장 사이즈</strong>
                    <br>가로 00px 세로 00px,
                    <br>10MB 이하
                  </p>
                  <p class="help-text is--warning">지원하지 않는 형식의 포맷 입니다.</p>
                  <form-error
                    name="files"
                    :error="error"
                  />
                </div>
              </div>
            </div>

          </template>
        </div>

      </div>

      <div class="clearfix">
        <div class="float--right pt--30px">
        </div>
      </div>
    </form> -->
    <board-password-dlg
      :isOpen="dlg.isOpen"
      :isError="dlg.isError"
      @closedDlg="onClosedDlg"
    />
  </div>
</template>

<script>
import boardEdit from './js/boardEdit'
import boardMeta from './js/boardMeta'
import theme from '@/component/js/theme'

export default {
  mixins: [boardEdit, boardMeta, theme],
  methods: {
    input (fieldId, $event) {
      this.row.etc = {
        ...this.row.etc,
        [fieldId]: $event
      }
    },
    goTree () {
      this.$router.push({ name: 'adminBoardDesignEdit' })
    }
  },
  components: {
    TextFieldInput: () => import('@/component/ui2/textfield/TextFieldInput'),
    TextFieldSelect: () => import('@/component/ui2/textfield/TextFieldSelect'),
    TextFieldToggle: () => import('@/component/ui2/textfield/TextFieldToggle'),
    TextFieldTextarea: () => import('@/component/ui2/textfield/TextFieldTextarea'),
    TextFieldUploads: () => import('@/component/ui2/textfield/TextFieldUploads'),
    TextFieldThumFiles: () => import('@/component/ui2/textfield/TextFieldThumFiles'),
    TextFieldEditor: () => import('@/component/ui2/textfield/TextFieldEditor')
    // FieldContainer: () => import('@/component/ui2/uicontainer/FieldContainer'),
    // FormToggle: () => import('@/component/ui2/form/FormToggle'),
    // FormCheckbox: () => import('@/component/ui2/form/FormCheckbox'),
    // FormInput: () => import('@/component/ui2/form/FormInput')

    // AdminPageTitle: () => import('@/app/admin/component/AdminPageTitle'),
    // FormFiles: () => import('@/component/ui/FormFiles'),
    // FormButton: () => import('@/component/ui/FormButton'),
    // FormInput: () => import('@/component/ui/FormInput'),
    // FormError: () => import('@/component/ui/FormError'),
    // FormToggle: () => import('@/component/ui/FormToggle'),
    // FormTextarea: () => import('@/component/ui/FormTextarea'),
    // FormSelect: () => import('@/component/ui/FormSelect'),
    // FormEditor: () => import('@/component/ui/FormEditor')
  }
}
</script>
